import EsgFeedComponent from './index';

export const EsgFeedPage = () => <EsgFeedComponent />;
